import { formSubmitHandler, toggleCashflowEvent, deleteCashflowEvent } from './helpers/sideEffects'
export const ADD_EVENT = 'ADD_EVENT'
export const ADD_EVENT_TYPE = 'ADD_EVENT_TYPE'
export const UPDATE_PROPS = 'UPDATE_PROPS'
export const BACK = 'BACK'
export const SET_FORM_VALIDITY = 'SET_FORM_VALIDITY'
export const FORM_DELETE = 'FORM_DELETE'
export const FORM_SUBMIT = 'FORM_SUBMIT'
export const EDIT_EVENT = 'EDIT_EVENT'
export const SET_INVALID_TOGGLE = 'SET_INVALID_TOGGLE'
export const GO_TO_OVERVIEW = 'GO_TO_OVERVIEW'
export const LOADING = 'LOADING'
export const LOADING_COMPLETE = 'LOADING_COMPLETE'

export const actionCreators = (dispatch, state) => ({
  goToOverview: () =>
    dispatch({
      type: GO_TO_OVERVIEW
    }),
  addEvent: () => {
    const { scenario } = state
    dispatch({
      type: ADD_EVENT,
      payload: { joint: !scenario?.id }
    })
  },
  addEventType: (eventType) =>
    dispatch({
      type: ADD_EVENT_TYPE,
      payload: { eventType }
    }),

  updateProps: (props) =>
    dispatch({
      type: UPDATE_PROPS,
      payload: { props }
    }),

  back: () =>
    dispatch({
      type: BACK
    }),

  setFormValidity: (formValidity) => {
    dispatch({
      type: SET_FORM_VALIDITY,
      payload: { formValidity }
    })
  },

  formDelete: (eventAttributes, context) => () => {
    deleteCashflowEvent(eventAttributes, context)
    dispatch({
      type: FORM_DELETE
    })
  },

  editEvent: (event) => () => {
    const { scenario } = state
    dispatch({
      type: EDIT_EVENT,
      payload: {
        event,
        joint: !scenario?.id
      }
    })
  },

  formSubmit: async (eventAttributes, context) => {
    dispatch({ type: LOADING })
    await formSubmitHandler(eventAttributes, context)
    dispatch({
      type: FORM_SUBMIT
    })
  },

  toggleEvent: async (eventAttributes, context) => {
    dispatch({ type: LOADING })
    await toggleCashflowEvent(eventAttributes, context)
    dispatch({ type: LOADING_COMPLETE })
  }
})
